const stateKeys = {
  token: 'token',
  apiUsername: 'apiUsername',
  apiPassword: 'apiPassword',
  apiCountry: 'apiCountry',
  language: 'language',
  languages: 'languages',
  aaltraAccount: 'aaltraAccount',
  marlonAccount: 'account'
}

export const state = () => ({ currency: 'EUR' })

export const mutations = {
  currency(state, value) {
    state.currency = value
  }
}

export const actions = {
  clearStorage() {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
  },
  getLanguage() {
    return this.$storage.getUniversal(stateKeys.language)
  },
  setLanguage(_, value) {
    this.$storage.setUniversal(stateKeys.language, value)
  },
  getAccountDetails() {
    return this.$storage.getUniversal(stateKeys.aaltraAccount)
  },
  setAccountDetails({ commit, dispatch }, account) {
    if (account && account.profile) {
      commit('currency', account.profile.currency)
      dispatch('energy/setHasSolar', account.profile.hasSolar, { root: true })
      dispatch('energy/setHasHeatpump', account.profile.hasHeatPump, {
        root: true
      })
      dispatch('energy/setShSupported', account.profile.shSupported, {
        root: true
      })
      dispatch('energy/setDhwSupported', account.profile.dhwSupported, {
        root: true
      })
      const budgetData = false
      dispatch('energy/setShowBudgetRelatedData', budgetData, { root: true })
      this.$storage.setUniversal(stateKeys.aaltraAccount, account)
    }
  },
  setMarlonAccountDetails(_, account) {
    this.$storage.setUniversal(stateKeys.marlonAccount, account)
  },
  getUserIsOnBlackList() {
    const account = this.$storage.getUniversal(stateKeys.marlonAccount)

    return (
      account &&
      account.customer_details &&
      account.customer_details.blacklist_level
    )
  },
  getUserIsPartiallyBlackListed() {
    const account = this.$storage.getUniversal(stateKeys.marlonAccount)

    return (
      account &&
      account.customer_details &&
      account.customer_details.blacklist_level === 'monthly'
    )
  }
}
